module.exports = __webpack_public_path__ + "static/media/memorial-heart-logo.8d46c557.svg";